import _ from "lodash";
import uid from 'uid';
import {store} from "../../../../utils/store";
import { takeScreenShot} from "../../../../helpers";
import { IMAGE_UPLOAD_STATUS_WAITING_FOR_UPLOAD } from "../../../../shared/redux/constants";
import {setImageData} from "../../../../shared/redux/actions";

const processImageUpdate = async (currentState,bridgesRef) => {
    const { patient, checkedTeeth, prevCheckedTeeth , addingBookingInfo , data } = currentState;

    let canUpdateImages;

    if (addingBookingInfo) {
        canUpdateImages = addingBookingInfo.bridges.length && bridgesRef
    } else if (data) {
        canUpdateImages = data.bridges.length && bridgesRef
    } else {
        canUpdateImages = patient.bridges.length &&
            bridgesRef &&
            !_.isEqual(checkedTeeth, prevCheckedTeeth)
    }

    if (canUpdateImages) {
        const filename = uid();
        const { dataURI, blob } = await takeScreenShot(bridgesRef);

        store.dispatch(setImageData({ [filename]: { filename, imageSrc: dataURI , binary: blob, status: IMAGE_UPLOAD_STATUS_WAITING_FOR_UPLOAD, contentType: 'image/png' } }));
    }
};


export {
    processImageUpdate,
}


// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AdminCaseDetails/helpers.js